import {
  ColumnBlockSchema,
  ColumnsBlockSchema,
} from '@blocksuite/affine-model';
import {
  BlockMarkdownAdapterExtension,
  type BlockMarkdownAdapterMatcher,
} from '@blocksuite/affine-shared/adapters';

/**
 * Columns are a layout primitive with no markdown equivalent, so both the
 * container and the individual columns are transparent: children are
 * emitted one after another.
 */
const passThroughMatcher = (flavour: string): BlockMarkdownAdapterMatcher => ({
  flavour,
  toMatch: () => false,
  fromMatch: o => o.node.flavour === flavour,
  toBlockSnapshot: {},
  fromBlockSnapshot: {},
});

export const columnsBlockMarkdownAdapterMatcher = passThroughMatcher(
  ColumnsBlockSchema.model.flavour
);

export const columnBlockMarkdownAdapterMatcher = passThroughMatcher(
  ColumnBlockSchema.model.flavour
);

export const ColumnsBlockMarkdownAdapterExtension =
  BlockMarkdownAdapterExtension(columnsBlockMarkdownAdapterMatcher);

export const ColumnBlockMarkdownAdapterExtension =
  BlockMarkdownAdapterExtension(columnBlockMarkdownAdapterMatcher);
